import { useRecoilValue } from 'recoil';
import * as Atom from '@/js/common/Atom';
import Util from '@/js/common/Util';
import Login from './Login';
import MainPage from './MainPage';

const Index = () => {
    const userInfo = useRecoilValue(Atom.userInfo);

    // 페이지 표시
    if (Util.isEmpty(userInfo.userId)) {
        return <Login />
    } else {
        return <MainPage />
    }
}
export default Index;